module.exports = __webpack_public_path__ + "static/media/DSC03734.509d1636.jpg";